const DECIMAL = new Intl.NumberFormat("pt-BR", {
  minimumFractionDigits: 1,
  maximumFractionDigits: 1,
});

const INTEGER = new Intl.NumberFormat("pt-BR");

const PERCENT = new Intl.NumberFormat("pt-BR", { maximumFractionDigits: 1 });

/** Número com uma casa, sem unidade: os rótulos sobre a curva do Capex. */
export function formatDecimal(valor: number): string {
  return DECIMAL.format(valor);
}

/** Valor do portfólio no formato do protótipo: `989,3 M`. */
export function formatMilhoes(valor: number): string {
  return `${DECIMAL.format(valor)} M`;
}

/** Valor inteiro em milhões, como nas linhas de subsistema: `22 M`. */
export function formatMilhoesInteiro(valor: number): string {
  return `${INTEGER.format(Math.round(valor))} M`;
}

/** Valor total da Obra, junto da unidade como no protótipo: `30,1M`. */
export function formatValorCompacto(valor: number): string {
  return `${DECIMAL.format(valor)}M`;
}

export function formatPercentual(valor: number): string {
  return `${PERCENT.format(valor)}%`;
}

/** Variação com sinal explícito, para distinguir economia de estouro: `-3%`. */
export function formatVariacaoPercentual(valor: number): string {
  const sinal = valor > 0 ? "+" : "";

  return `${sinal}${formatPercentual(valor)}`;
}

export function formatQuantidade(valor: number): string {
  return INTEGER.format(valor);
}

/** Contagem em duas casas, como nas naturezas de GMUD do protótipo: `07`. */
export function formatContagem(valor: number): string {
  return INTEGER.format(valor).padStart(2, "0");
}

/** Realizado sobre o total de um escopo: `600/1.000`. */
export function formatFracao(realizado: number, total: number): string {
  return `${formatQuantidade(realizado)}/${formatQuantidade(total)}`;
}

/**
 * Data ISO (`YYYY-MM-DD`) em `dd/mm/aa`, como na tarja da Obra. As partes são
 * lidas do texto em vez de passarem por `Date`, que interpretaria a data como
 * UTC e poderia exibir o dia anterior. Um valor fora do padrão volta como veio.
 */
export function formatDataCurta(iso: string): string {
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(iso.trim());
  if (!match) return iso;

  const [, ano = "", mes, dia] = match;

  return `${dia}/${mes}/${ano.slice(2)}`;
}

/** Duração em dias, como na tarja da Obra: `31 d`. */
export function formatDuracao(dias: number): string {
  return `${formatQuantidade(dias)} d`;
}
